<!--@created ana.castro 2019.08.19 SABO-1056-->
<!--https://www.instagram.com/developer/authentication/ -->
<template>
    <v-btn @click="click">
        <v-icon color="primary">fab fa-instagram</v-icon>
    </v-btn>
</template>

<script>
    export default {
        name: "IGLoginButton",

        mounted() {

            //Defining the Login Provider
            let provider = "IG";

            //Instagram redirect with the access_token in the url fragment
            let code = this.$route.query.code;

            const {dispatch} = this.$store;

            if (provider && code) {
                this.$log.debug("Social Sign | INSTAGRAM | Success");

                dispatch('authentication/setLoginProvider', {provider, code});

                dispatch('authentication/loginSocialProvider', {provider, code});
            } else {
                this.$log.debug("Social Sign | INSTAGRAM | User cancelled login or did not fully authorize");
                // getErrorMessage(undefined, 'Social Sign | INSTAGRAM', this);
            }
        },
        methods: {
            click() {
                // Put the full page url including the protocol http(s) below
                window.location = "https://api.instagram.com/oauth/authorize/?client_id=9010333bbf30434ea369d930d94e4988&redirect_uri=http://localhost:8080/login?origin=ig&response_type=code"
                //https://api.instagram.com/oauth/authorize/?client_id=9010333bbf30434ea369d930d94e4988&redirect_uri=http://localhost:8080/login?origin=ig&response_type=code
            }
        }
    }
</script>

<style scoped>

</style>